import Page, { getServerSideProps } from 'pages/[lang]/features/compliments';

export default Page;

export { getServerSideProps };
